import { motion } from "framer-motion";
import { useScrollReveal } from "@/hooks/useScrollReveal";
// ✅ Import de la imagen local
import variosLogos from "@/assets/images/historia/varios-logos.png";

export default function Historia() {
  const { ref, isVisible } = useScrollReveal();

  return (
    <section id="historia" ref={ref} className="py-28 md:py-40 px-6 lg:px-10 bg-background">
      <div className="max-w-4xl mx-auto text-center">
        <motion.span
          initial={{ opacity: 0 }}
          animate={isVisible ? { opacity: 1 } : {}}
          transition={{ duration: 1 }}
          className="text-accent text-sm tracking-[0.3em] uppercase font-light mb-8 block"
        >
          Nuestra Historia
        </motion.span>

        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          animate={isVisible ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 1.2, delay: 0.1 }}
          className="font-serif-display text-4xl md:text-5xl lg:text-6xl font-light text-foreground text-balance leading-tight"
        >
          Un refugio donde el tiempo se detiene
        </motion.h2>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isVisible ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 1.2, delay: 0.3 }}
          className="mt-10 space-y-6 text-foreground/70 font-light text-lg leading-relaxed text-balance"
        >
          <p>
            Casa El Gavillero nació de un sueño: crear un espacio donde la
            naturaleza, el diseño y la tranquilidad converjan en una sola
            experiencia. Cada rincón fue pensado para conectar al huésped
            con la esencia del lugar.
          </p>
          <p>
            Desde su concepción, la propiedad ha sido un refugio privado para
            quienes buscan escapar del ritmo acelerado y redescubrir el arte
            de vivir con calma. La arquitectura respeta el paisaje, los
            materiales honran la tierra y la luz natural es la protagonista
            de cada espacio.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={isVisible ? { opacity: 1 } : {}}
          transition={{ duration: 1.2, delay: 0.5 }}
          className="mt-12 flex items-center justify-center gap-12"
        >
          <div className="text-center">
            <p className="font-serif-display text-4xl text-accent font-light">15</p>
            <p className="text-sm text-muted-foreground font-light mt-1">Años de historia</p>
          </div>
          <div className="w-px h-12 bg-border" />
          <div className="text-center">
            <p className="font-serif-display text-4xl text-accent font-light">100%</p>
            <p className="text-sm text-muted-foreground font-light mt-1">Diseño boutique</p>
          </div>
          <div className="w-px h-12 bg-border" />
          <div className="text-center">
            <p className="font-serif-display text-4xl text-accent font-light">5★</p>
            <p className="text-sm text-muted-foreground font-light mt-1">Experiencia premium</p>
          </div>
        </motion.div>
      </div>

      <div className="flex justify-center py-10">
        <img
          src={variosLogos}
          alt="Logotipos"
          className="w-full h-auto max-w-xl my-16 pt-2"
        />
      </div>
    </section>
  );
}